/** Ввод длительности «чч:мм:сс»: общая логика полей времени старого и нового интерфейса */

const MAX_TIME_DIGITS = 6;
const HOURS_MAX = 23;
const MINUTES_MAX = 59;
const PASTED_TIME = /^(\d{1,2}):(\d{2}):(\d{2})$/;

/** Только чч:мм → чч:мм:00 при уходе фокуса (секунды не вводили). */
export function padSecondsIfTwoParts(value: string): string {
  const t = value.trim();
  if (!t) return '';
  const m = t.match(/^(\d{1,2}):(\d{2})$/);
  if (!m) return t;
  const h = Number(m[1]);
  const mi = Number(m[2]);
  if (h > HOURS_MAX || mi > MINUTES_MAX) return t;
  return `${String(h).padStart(2, '0')}:${m[2]}:00`;
}

/** Форматирование ввода времени: оставляем только цифры и форматируем в чч:мм:сс */
export function formatTimeForInput(input: string): string {
  const numbersOnly = input.replace(/[^0-9]/g, '');
  let formattedTime = numbersOnly.slice(0, MAX_TIME_DIGITS);
  if (formattedTime.length > 2) {
    formattedTime = `${formattedTime.slice(0, 2)}:${formattedTime.slice(2)}`;
  }
  if (formattedTime.length > 5) {
    formattedTime = `${formattedTime.slice(0, 5)}:${formattedTime.slice(5)}`;
  }
  return formattedTime;
}

/** Вставленный текст: «7:45:12» → «07:45:12», остальное — как набранное с клавиатуры */
export function formatPastedTime(pastedText: string): string {
  const match = pastedText.match(PASTED_TIME);
  return match ? `${match[1]!.padStart(2, '0')}:${match[2]}:${match[3]}` : formatTimeForInput(pastedText);
}

/**
 * Куда встаёт курсор, когда `format` переписал набранный `text`: после того же знака, за которым он стоял.
 * Считается по началу текста до курсора — формат времени от продолжения строки не зависит.
 */
export function caretAfterFormat(format: (text: string) => string, text: string, offset: number): number {
  return format(text.slice(0, offset)).length;
}

/** Формат поля времени: набор, вставка и уход из поля. Одна запись для всех полей «чч:мм:сс» */
export const TIME_INPUT_FORMAT = {
  onInput: formatTimeForInput,
  onPaste: formatPastedTime,
  onLeave: padSecondsIfTwoParts,
};
